import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getServices } from "../../apiServices/apiServices";
import toast from "react-hot-toast";
import LoadingGif from "../../assets/loading_anim.gif";
import CylinderReportTable from "../../components/common/CylinderReportTable";

function CylinderWeightReport() {
  const [loading, setLoading] = useState(false);
  const [cylinderList, setCylinderList] = useState([]);
  const navigate = useNavigate();
  const { branch_id } = useParams();
  const access_token =
    localStorage.getItem("gassol-super-admin-token") ||
    localStorage.getItem("gassol-admin-token") ||
    localStorage.getItem("gassol-head-branch-token") ||
    localStorage.getItem("gassol-sub-branch-token");

  useEffect(() => {
    if (!access_token) {
      navigate("/sign_in");
    }

    window.scrollTo(0, 0);

    fetchCylinderWeightList();
  }, []);

  const fetchCylinderWeightList = async () => {
    setLoading(true);

    try {
      const res = await getServices(
        // `/api/list/cylinder/weight?branch_id=${location.state?.branch_id}`,
        `/api/list/cylinder/weight?branch_id=${branch_id}`,
        access_token
      );
      setLoading(false);
      if (res.responseCode === 200) {
        setCylinderList(res.responseData);
      } else {
        setCylinderList([]);
      }
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="py-4 md:py-8 max-w-[1400px] mx-auto px-3">
        {!loading ? (
          <>
            <div className="flex gap-2 md:justify-between items-start md:items-center flex-col md:flex-row">
              <div className="flex gap-3 sm:gap-6">
                <Link
                  to={-1}
                  className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
                >
                  {/* <IoChevronBackOutline /> */}
                  <p>Cylinder Report</p>
                </Link>
              </div>
            </div>

            {/* cylinder report table */}
            <CylinderReportTable cylinderList={cylinderList} />
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

export default CylinderWeightReport;
